import { render, staticRenderFns } from "./DashboardSettingsDrawer.vue?vue&type=template&id=7f5cbdde&"
import script from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js&"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports